import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';

const environment = import.meta.env.VITE_ENVIRONMENT ?? 'development';
Sentry.init({
  dsn: 'https://d1d7fc68a7e4487997df702fcf24c41c@o4510901715795968.ingest.de.sentry.io/4510901726412880',
  environment,
  enabled: import.meta.env.PROD,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.2,
});
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { ApiClientProvider } from '@wovendays/api-client';
import { I18nProvider } from '@wovendays/i18n';
import LanguageDetector from 'i18next-browser-languagedetector';
import { apiClient } from '@/lib/api-client';
import { ThemeProvider } from '@/components/theme-provider';
import { initPostHog } from '@/lib/posthog';
import { PostHogPageView } from '@/components/PostHogPageView';
import App from './App';
import './index.css';

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

// Register service worker for image caching
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js');
}

initPostHog();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nProvider detector={LanguageDetector}>
      <ApiClientProvider value={apiClient}>
        <BrowserRouter>
          <PostHogPageView />
          <ThemeProvider defaultTheme="system">
            <App />
          </ThemeProvider>
        </BrowserRouter>
      </ApiClientProvider>
      </I18nProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </React.StrictMode>
);
